// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"1b0b0d88","453":"fe9dcb7b"}[chunkId] + ".chunk.js";
};